import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { Spinner } from '@ami/react/core';
import { apiFetch } from '@ami/react/core';
import QuoteView from '../quoteView';
import QuoteDiscountModalComponent from './QuoteDiscountModalComponent';

export default class QuoteDiscountComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      downloading: false,
    };
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
  }
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    quoteDiscount: PropTypes.object.isRequired,
    refreshQuote: PropTypes.func.isRequired,
  };
  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  downloadDocument = async () => {
    const { quote, quoteDiscount } = this.props;
    this.setState({ downloading: true });
    const response = await apiFetch(
      `quotes/${quote.id}/discount-documentation/${quoteDiscount.discountId}`
    );
    window.location = response.url;
    this.setState({ downloading: false });
  };

  render() {
    const { quoteDiscount } = this.props;
    return (
      <div className="card mb-3 box-shadow flex-fill">
        <div className="card-body">
          <h6 className="card-title text-center">{quoteDiscount.discountName}</h6>
          <div className="d-flex justify-content-center">
            <div className="text-center">
              {!quoteDiscount.documentationFileKey && (
                <div>
                  <div>
                    No document has been provided yet
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => this.handleShowModal()}
                    >
                      Upload Document
                    </button>
                  </div>
                </div>
            )}
            {quoteDiscount.documentationFileKey && (
              <Button
                color="outline-primary"
                className="btn-sm"
                onClick={() => this.downloadDocument()}
              >
                {this.state.downloading && <span>Downloading...</span>}
                {!this.state.downloading && (
                  <span>
                    Download Document <span className="fa fa-download" />
                  </span>
                )}
                <Spinner show={this.state.downloading} />
              </Button>
            )}
          </div>
          </div>
        </div>
        <QuoteDiscountModalComponent
          quote={this.props.quote}
          quoteDiscount={quoteDiscount}
          refreshQuote={this.props.refreshQuote}
          showModal={this.state.showModal}
          hideModal={this.handleHideModal}
        />
      </div>
    );
  }
}
